import React, { useState, useEffect } from 'react';

const WarningOverlay = ({ currentTime }) => {
  const [showWarning, setShowWarning] = useState(false);
  
  useEffect(() => {
    // Show warning during the lift segment at around 4:12 (252 seconds)
    // The warning will be visible from 4:12 to 4:17 (252-257 seconds)
    if (currentTime >= 252 && currentTime < 257) {
      setShowWarning(true);
    } else {
      setShowWarning(false);
    }
  }, [currentTime]);
  
  if (!showWarning) {
    return null;
  }
  
  return (
    <div className="video-overlay warning-overlay animate-flash">
      <div className="flex flex-col items-center">
        <div className="text-5xl mb-2">⚠️</div>
        <div className="text-white text-lg font-bold">
          Be careful with this lift — many shoulders went out here.
        </div>
      </div>
    </div>
  );
};

export default WarningOverlay;
